import React from "react";
import { notification } from "antd";
import requestAdmin from "./requestAdmin";

// GET /api/ccadmin/edu-report/pending-approvals
// Ответ: { total: number, items: [{ reportId, reportName, organizationName,
//   createdAt, deadline, daysRemaining }] }
export const PENDING_REPORTS_URL = "/edu-report/pending-approvals";

const NOTIFICATION_KEY = "pendingReportsNotification";

// 1 отчет, 2 отчета, 5 отчетов
const pluralize = (count, [one, few, many]) => {
  const mod10 = count % 10;
  const mod100 = count % 100;
  if (mod10 === 1 && mod100 !== 11) return one;
  if (mod10 >= 2 && mod10 <= 4 && (mod100 < 12 || mod100 > 14)) return few;
  return many;
};

const showPendingReportsNotification = (count) => {
  const reports = pluralize(count, ["отчет", "отчета", "отчетов"]);
  const waiting = count % 10 === 1 && count % 100 !== 11 ? "ожидающий" : "ожидающих";

  notification.warning({
    key: NOTIFICATION_KEY,
    message: "Требуется согласование отчетов",
    description: (
      <>
        <p>
          У вас имеется {count} {reports}, {waiting} согласования.
        </p>
        <p>
          Срок согласования отчетов — не более 30 календарных дней с даты
          создания.
        </p>
        <p style={{ marginBottom: 0 }}>
          Перейдите в раздел «Отчеты» для их рассмотрения.
        </p>
      </>
    ),
    // Висит, пока пользователь сам не закроет
    duration: 0,
  });
};

export const closePendingReportsNotification = () =>
  notification.close(NOTIFICATION_KEY);

// Вызывается после успешной авторизации. Ошибки запроса показывает
// стандартный механизм performRequest, здесь их только глушим.
export const checkPendingReports = async () => {
  try {
    const response = await requestAdmin(PENDING_REPORTS_URL, { method: "GET" });
    const items = Array.isArray(response && response.items)
      ? response.items
      : [];
    // total считает бек; если его нет — считаем по items
    const count = Number.isInteger(response && response.total)
      ? response.total
      : items.length;
    if (count > 0 && items.length > 0) {
      showPendingReportsNotification(count);
    }
  } catch (err) {
    // АС2: уведомление не показываем
  }
};
